import { useNotifications } from "reapop";
import client from "./client";
import { useMutation, useQuery } from "@tanstack/react-query";
import { queryClient } from "queryclient";

export const GetEmploymentBanner = () => {
  const getBanner = useQuery({
    queryKey: ["get-employment-banner"],
    queryFn: () => client.employment.getEmploymentBanner(),
  });
  return getBanner;
};

export const UpdateEmploymentBanner = () => {
  const { notify } = useNotifications();
  const employmentBanner = useMutation({
    mutationFn: (data) => client.employment.updateEmploymentBanner(data),
    onSuccess: () => {
      notify("Details Added Successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-employment-banner"] });
    },

    onError: () => notify("OOPS! some error occured", "error"),
  });
  return employmentBanner;
};

export const GetEmploymentResponsibilities = () => {
  const getResponsibilities = useQuery({
    queryKey: ["get-employment-responsibilities"],
    queryFn: () => client.employment.getEmploymentResponsibilities(),
  });
  return getResponsibilities;
};

export const UpdateEmploymentResponsibilities = () => {
  const { notify } = useNotifications();
  const employmentResponsibilities = useMutation({
    mutationFn: (data) =>
      client.employment.updateEmploymentResponsibilities(data),
    onSuccess: () => {
      notify("Details Added Successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["get-employment-responsibilities"],
      });
    },

    onError: () => notify("OOPS! some error occured", "error"),
  });
  return employmentResponsibilities;
};

export const GetResumes = () => {
  const getResumes = useQuery({
    queryKey: ["get-resumes"],
    queryFn: () => client.employment.getResumes(),
  });
  return getResumes;
};

export const DeleteResumes = () => {
  const { notify } = useNotifications();
  const deleteResumes = useMutation({
    mutationFn: (data) => client.employment.deleteResume(data),
    onSuccess: () => {
      notify("Data Deleted Successfully", "success");
      queryClient.invalidateQueries({
        queryKey: ["get-resumes"],
      });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });

  return deleteResumes;
};

export const GetEmploymentExploreHeading = () => {
  return useQuery({
    queryKey: ["get-employment-explore-heading"],
    queryFn: () => client.employment.getEmploymentExploreHeading(),
  });
};

export const UpdateEmploymentExploreHeading = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.employment.updateEmploymentExploreHeading(data),
    onSuccess: () => {
      notify("Heading updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-employment-explore-heading"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};

export const GetAllEmploymentExploreLinks = () => {
  return useQuery({
    queryKey: ["get-employment-explore-links"],
    queryFn: () => client.employment.getAllEmploymentExploreLinks(),
  });
};

export const CreateEmploymentExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.employment.newEmploymentExploreLink(data),
    onSuccess: () => {
      notify("Link added successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-employment-explore-links"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};

export const UpdateEmploymentExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.employment.updateEmploymentExploreLink(data),
    onSuccess: () => {
      notify("Link updated successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-employment-explore-links"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};

export const DeleteEmploymentExploreLink = () => {
  const { notify } = useNotifications();
  return useMutation({
    mutationFn: (data) => client.employment.deleteEmploymentExploreLink(data),
    onSuccess: () => {
      notify("Link deleted successfully", "success");
      queryClient.invalidateQueries({ queryKey: ["get-employment-explore-links"] });
    },
    onError: () => notify("OOPS! some error occured", "error"),
  });
};
